import React, { useState } from 'react';
import LiveTripsRiderView from './rider-view';
import LiveTripsLiveView from './live-view';
import { NetworkProvider } from 'contexts/network.context';

const LiveTrips = () => {
  const [isLiveView, setIsLiveView] = useState(true);

  return (
    <NetworkProvider>
      <div>
        <div className={!isLiveView ? 'hidden' : ''}>
          <LiveTripsLiveView setView={() => setIsLiveView(!isLiveView)} />
        </div>
        {!isLiveView && <LiveTripsRiderView setView={() => setIsLiveView(!isLiveView)} />}
      </div>
    </NetworkProvider>
  );
};

export default LiveTrips;
